import { EventEmitter } from 'events';
class PreferenceStore {
    constructor() {
        this.emitter = new EventEmitter();
        this.geodesic = false;
    }
    isGeodesicEnabled() {
        return this.geodesic;
    }
    setGeodesicEnabled(enabled) {
        if (this.geodesic === enabled)
            return;
        this.geodesic = enabled;
        this.emitter.emit('geodesicChange', enabled);
    }
    subscribe(eventName, listener) {
        this.emitter.on(eventName, listener);
        return () => this.emitter.off(eventName, listener);
    }
}
export const RenderingPreferences = new PreferenceStore();
